import React from 'react';
import { ArrayHelpers, Copy, Loading, Modal, SystemText } from 'e4shared';
import PredictiveModel from 'views/myDashboard/components/widgets/predictiveModel/chart';
import { apiGet } from 'services';
import { useSelector } from 'react-redux';
import Recommends from './recommendations';
import { isPast } from 'helpers/dates';

export const PredictiveModelWrapper = ({ show, onClose, profile, filterCompetencies, ...rest }) => {
    const [data, setData] = React.useState(null);
    const [goals, setGoals] = React.useState(null);
    const [goal, setGoal] = React.useState(null);
    const [goalSet, setGoalSet] = React.useState(false);
    const [goalTarget, setGoalTarget] = React.useState(null);
    const [item, setItem] = React.useState(null);
    const [fy, setFy] = React.useState('Y1');
    const [loading, setLoading] = React.useState(true);
    const user = useSelector(state => state.user.user);
    const title = SystemText('User121/PredictiveModel/Title', profile?.full_Name);

    const obscurer = React.useRef(null);

    React.useEffect(() => {
        if (data && goal) {
            const fy = user.fy_Start_Date ? new Date(user.fy_Start_Date) : new Date(2000, 1, 1);
            const fyMonth = fy.getMonth();
            let qMonths = [fyMonth, fyMonth + 3, fyMonth + 6, fyMonth + 9];
            qMonths = qMonths.map(m => (m = m >= 12 ? m - 12 : m));
            const target = data.data.data.reduce((a, c) => {
                const d = new Date(c.x);
                const g = goal.values
                    .sort((a, b) => (a.valid_For > b.valid_For ? -1 : 1))
                    .find(g => new Date(g.valid_For) <= new Date(d));
                const v = g?.value || 0;
                if (goal.period === 'M') {
                    return a + v;
                } else if (goal.period === 'Q') {
                    return qMonths.some(x => x === d.getMonth()) ? a + v : a;
                } else {
                    return d.getMonth() === fyMonth ? a + v : a;
                }
            }, 0);

            setGoalTarget(target);
        }
    }, [data, goal, fy]);

    React.useEffect(() => {
        const parent = document.getElementById('modal-body');
        if (obscurer.current) {
            const w = parent.clientWidth;
            const h = parent.clientHeight + 100;
            parent.style.overflow = 'hidden';
            obscurer.current.style.height = `${h}px`;
            obscurer.current.style.width = `${w}px`;
        }
    }, [obscurer.current]);

    React.useEffect(() => {
        if (show && profile) {
            setLoading(true);
            apiGet(`profile/${profile.id}/121model?fy=${fy}`, user.guid, response => {
                setData(response);
            });

            apiGet(`quota-values/${profile.id}`, user.guid, response => {
                setGoals(
                    response
                        .filter(g => g.isClosedWon)
                        .map(g => ({ ...g, sort: g.period === 'Y' ? 1 : g.period === 'Q' ? 2 : g.period === 'M' ? '3' : 4 }))
                        .sort((a, b) => (a.sort > b.sort ? 1 : -1))
                );
            });
        }
    }, [show, profile]);

    React.useEffect(() => {
        ArrayHelpers.existsAndHasLength(goals) && setGoal(goals[0]);
    }, [goals]);

    React.useEffect(() => {
        goal && setGoalSet(goal.values.some(v => isPast(v.valid_For)));
    }, [goal]);

    React.useEffect(() => {
        if (show && profile) {
            apiGet(`profile/${profile.id}/121model?fy=${fy}`, user.guid, response => {
                setData(response);
            });
        }
    }, [fy]);

    React.useEffect(() => {
        if (data && goalTarget !== null) {
            data.extra = data.extra || {};
            data.extra.target = goalTarget;
            const temp = data.extra ? JSON.stringify(data.extra) : '{}';
            const tempItem = item ? { ...item } : {};
            setItem({ ...tempItem, user_Data: temp });
            setLoading(false);
        }
    }, [data, goalTarget]);

    const reload = () => {
        apiGet(`profile/${profile.id}/121model`, user.guid, response => {
            setData({ ...data, recommendation: response.recommendation });
        });
    };

    const footer = (
        <div>
            {goalSet && (
                <div className="btn-group pull-left">
                    <button className={`btn btn-${fy === 'Y1' ? 'primary' : ''}`} onClick={() => setFy('Y1')}>
                        {SystemText('Dashboard/Widgets/PredictiveModel/Fields/FY/This')}
                    </button>
                    <button className={`btn btn-${fy === 'Y2' ? 'primary' : ''}`} onClick={() => setFy('Y2')}>
                        {SystemText('Dashboard/Widgets/PredictiveModel/Fields/FY/Next')}
                    </button>
                </div>
            )}
            <div className="pull-right">
                <button className="btn" onClick={onClose}>
                    {SystemText('Admin/General/Modal/Buttons/Close')}
                </button>
            </div>
        </div>
    );

    return (
        <Modal
            className="modal-max"
            show={show}
            close={onClose}
            title={title}
            footer={footer}
            sliderContent={
                goalSet ? (
                    <Recommends recommendationData={data?.recommendation} filterCompetencies={filterCompetencies} />
                ) : null
            }
        >
            <div id="predictive-model-wrapper">
                {!goalSet && !loading && (
                    <>
                        <div
                            ref={obscurer}
                            data-testid="model-no-goal"
                            style={{
                                position: 'absolute',
                                background: '#fff',
                                zIndex: 9999,
                                opacity: '0.75',
                            }}
                        ></div>
                        <div
                            className="text-center"
                            style={{
                                zIndex: 99999,
                                width: '70%',
                                marginLeft: '10%',
                                marginTop: '10%',
                                position: 'absolute',
                            }}
                        >
                            <div
                                className="p10"
                                style={{
                                    background: '#fff',
                                    border: 'solid 1px #ebebeb',
                                    borderRadius: '3px',
                                    position: 'relative',
                                }}
                            >
                                <h4 className="no-wrap">
                                    <Copy
                                        value={
                                            profile?.id === user?.id
                                                ? SystemText('User121/PredictiveModel/NoGoals/You', goal?.name)
                                                : SystemText(
                                                      'User121/PredictiveModel/NoGoals/Them',
                                                      profile?.first_Name,
                                                      goal?.name
                                                  )
                                        }
                                    />
                                </h4>
                            </div>
                        </div>
                    </>
                )}
                {!loading ? (
                    <PredictiveModel
                        {...rest}
                        data={data?.data}
                        item={item}
                        reload={reload}
                        profileId={profile?.id}
                        disableTarget
                        id="predictive-model-wrapper"
                    />
                ) : (
                    <Loading />
                )}
            </div>
        </Modal>
    );
};

export default PredictiveModelWrapper;
